import { useRouter } from 'next/router'
import { ParsedUrlQuery } from 'querystring'

export type UseNavigatorResult = (
  url: string,
  opts?: {
    replace?: boolean
    preserveQs?: boolean
    resetScroll?: boolean
    excludeParams?: string[]
  }
) => void

export const preserveParams = []
export const preDefinedExcludeParams = [
  'filters',
  'pages',
  'slug',
  'country',
  'restricted',
  'language',
  'sortBy',
  'session_id',
  'q',
  'size',
  'soldOnline',
  'wishlist',
  'basket',
  'cart',
  'orderId',
  'payment_intent',
  'itemNumber',
  'payment_intent_client_secret',
  'redirect_status',
]
function useNavigator(): UseNavigatorResult {
  const router = useRouter()

  return (
    url: string,
    {
      replace = false,
      preserveQs = true,
      resetScroll = false,
      excludeParams = [],
    } = {}
  ) => {
    const currentQueryParams: ParsedUrlQuery = router.query
    const filteredQueryParams: ParsedUrlQuery = Object.keys(
      currentQueryParams
    ).reduce((acc, key) => {
      if (![...excludeParams, ...preDefinedExcludeParams].includes(key)) {
        acc[key] = currentQueryParams[key]
      }
      return acc
    }, {})

    const queryParamString = new URLSearchParams(
      filteredQueryParams as any
    ).toString()
    const queryParams = preserveQs ? `?${queryParamString}` : ''
    const targetUrl = `${url}${queryParams}`

    if (!targetUrl) return
    if (replace) {
      router.replace(targetUrl)
    } else {
      router.push(targetUrl)
    }
    if (resetScroll) {
      window.scrollTo({ behavior: 'smooth', top: 0 })
    }
  }
}

export default useNavigator
